import { createContext } from "react";
import { AdminModalContextInterface } from "../../Interfaces/ContextInterfaces/AdminModalContextInterface";

const AdminModalContext = createContext<AdminModalContextInterface | undefined>(undefined);

export default AdminModalContext;